<template>
  <div class="wrapper">
    <div class="list">
      <div class="list__item" v-for="(item, index) in data"
           :key="item.name">
        <div class="list__item_name-wrapper">
          <span class="list__item-color" :style="getItemColorClass(index)"></span>
          <span class="list__item-name" :title="item.name">{{item.name}}</span>
        </div>
        <div class="list__item-intermediate">
          <span>{{item.percent | roundNumber(2)}}%</span>
        </div>
        <div class="list__item-number">
          <span>{{item.value | roundNumber | commaDividedNumber}}</span>
        </div>
      </div>
    </div>
    <BasePieChart :list="data" class="pie-chart"></BasePieChart>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import _ from 'lodash'
import { allColors } from '@/common/BasePieChart'
import filters from '@/common/Filters'
import AttributeReport from './AttributeReport'
/**
 * Comparison component used in {@link AttributeReport}
 */
export default {
  name: 'PieChart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    charData () {
      return this.handlePropsData()
    }
  },
  methods: {
    handlePropsData () {
      return _.cloneDeep(this.data)
    },
    getItemColorClass (index) {
      return { 'background-color': allColors[ index ] }
    }
  },
  filters: {
    roundNumber: filters.roundNumber,
    commaDividedNumber: filters.commaDividedNumber
  }

}
</script>

<style scoped lang="scss">

  .wrapper {
    display: flex;
    width: 100%;
    justify-content: stretch;
  }

  .list {
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__item {
      display: flex;
      justify-content: space-between;
      height: 30px;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      color: $rfx-dark-march;

      &:first-child {
        font-weight: bold;
        color: $rfx-dark-march;
      }

      &-color {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
        margin: 0 10px 0 0;
        flex-shrink: 0;
      }

      &-number {
        flex: 0 0 70px;
        display: flex;
        justify-content: flex-end;
        padding-left: 15px;
      }

      &-intermediate {
        flex: 0 0 30px;
        text-align: right;
      }

      &-name {
        font-size: 12px;
        font-weight: 500;
        @include ellipsis
      }

      &_name-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
        flex: 1 1;
        padding-right: 15px;
        overflow: hidden;
      }
    }
  }

  .pie-chart {
    flex: 1 1 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
